























import moment from 'moment'
import { computed, defineComponent } from '@vue/composition-api'
import { ISpecialOffer } from '@/types/special-offer'

type Props = {
  specialOffers: ISpecialOffer[]
  loading: boolean
}

export default defineComponent({
  name: 'SpecialOffersTable',
  props: {
    specialOffers: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props: Props) {
    const headers = [
      { text: '案件ID', value: 'id' },
      { text: '管理名', value: 'nameAdmin' },
      { text: '案件名', value: 'title' },
      { text: '総数', value: 'total' },
      { text: '未チェック', value: 'unchecked' },
      { text: 'リーダーNG残', value: 'uncheckedNg' },
      { text: 'リーダーOK残', value: 'uncheckedOk' },
      { text: 'リーダーOK', value: 'leaderChecked' },
      { text: 'リーダーNG', value: 'leaderNg' },
      { text: '設定', value: 'settings' },
    ]

    const items = computed(() =>
      props.specialOffers.map(q => ({
        ...q,
      })),
    )

    return { props, headers, moment, items }
  },
})
